import { UtcStringToZonedTimeStringFormatted } from '@tsyl/radon'

export function getTomorrow(): Date {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  return d
}

/**
 * Converts a date and time to a string by using the current or specified locale.
 * @param {string} utcDate Date in utc (ISO format, It must end in Z)
 * @param {string} timezone IANA timezone name.
 * @param {string} format Optional. A date format [date-fns Reference](https://date-fns.org/v4.1.0/docs/format). Default format 'dd-MM-yyyy HH:mm:ss'.
 * @returns {string} A string date with given format or default format
 */
export function getDateString(
  utcDate: string,
  timezone: string = 'Europe/Madrid',
  format: string = 'dd-MM-yyyy HH:mm:ss',
): string {
  return UtcStringToZonedTimeStringFormatted(utcDate, timezone, format)
}

export function isDateOlderThan(dateA: string, dateB: string): boolean {
  return new Date(dateA).getTime() < new Date(dateB).getTime()
}
